const zoomIntentSelector = '.product-media-container--zoomable, .product-media-container__zoom-button';
const deferredTemplateSelector = 'template[data-seal-product-zoom-content]';

function hydrateProductZoom(gallery) {
  if (!(gallery instanceof Element)) return;

  const dialog = gallery.querySelector('zoom-dialog[data-seal-product-zoom-deferred]');
  if (!(dialog instanceof HTMLElement) || dialog.dataset.sealProductZoomHydrated === 'true') return;

  for (const template of dialog.querySelectorAll(deferredTemplateSelector)) {
    if (!(template instanceof HTMLTemplateElement)) continue;
    template.replaceWith(template.content.cloneNode(true));
  }

  dialog.dataset.sealProductZoomHydrated = 'true';
}

function handleZoomIntent(event) {
  if (!(event.target instanceof Element) || !event.target.closest(zoomIntentSelector)) return;
  hydrateProductZoom(event.target.closest('media-gallery'));
}

document.addEventListener('pointerover', handleZoomIntent, { capture: true, passive: true });
document.addEventListener('touchstart', handleZoomIntent, { capture: true, passive: true });
document.addEventListener('focusin', handleZoomIntent, true);
document.addEventListener('click', handleZoomIntent, true);
